/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { OverridableComponent, OverrideProps } from '@coursera/cds-common';

interface BasicCardTypeMap<D extends React.ElementType = 'div'> {
  props: {};
  defaultComponent: D;
}

type BasicCardProps<D extends React.ElementType = BasicCardTypeMap['defaultComponent']> = OverrideProps<
  BasicCardTypeMap<D>,
  D
> & { component?: React.ElementType };

const styles = {
  card: css`
    transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
    transform: translateZ(0);

    &:hover {
      box-shadow:
        0 0 12px -6px var(--cds-color-darken-300),
        0 0 12px -8px var(--cds-color-darken-300);
      transform: scale3d(1.01, 1.01, 1.01) translate3d(1px, -2px, 16px);
    }
  `,
};

const HoverEffectWrapper = React.forwardRef<HTMLDivElement, BasicCardProps>(
  ({ component: Component = 'div', children, ...props }, ref) => (
    <Component ref={ref} {...props} css={styles.card}>
      {children}
    </Component>
  )
) as OverridableComponent<BasicCardTypeMap>;

HoverEffectWrapper.displayName = 'HoverEffectWrapper';

export default HoverEffectWrapper;
